<template>
  <el-dialog
    title="Copiar y rotar turnos"
    :visible="visible"
    @close="$emit('close')"
    width="80%"
  >
    <el-form
      :model="copyAndRotateForm"
      ref="copyAndRotateForm"
      @submit.prevent="handleCopyAndRotate"
      size="mini"
    >
      <!-- prop="original.original_date_from" required :rules="[{required: true, message: 'Campo requerido'}]" -->
      <el-form-item
        label="Semana a copiar"
        prop="original.date_from"
        label-width="140px"
        :rules="[{validator: checkOriginalDate}]"
      >
        <el-week-picker
          :value="copyAndRotateForm.original.date_from"
          @input="copyAndRotateWeekPickerChange"
          type="week"
          format="yyyy-MM-dd"
          placeholder="Seleccione una semana"
        >
        </el-week-picker>
      </el-form-item>
      <el-row :gutter="20">
        <el-col
          v-for="(shift, key) in shiftsOptions"
          :key="key"
          :sm="24"
          :md="12"
        >
          <el-form-item
            :label="shift.label"
            label-width="180px"
          >
            <el-select
              v-model="copyAndRotateForm.rotation[key].dest"
              clearable
              filterable
              placeholder="No copiar"
            >
              <el-option
                v-for="item in shiftsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$emit('close')">Cancelar</el-button>
      <el-button
        type="primary"
        @click="handleCopyAndRotate"
      >Confirmar</el-button>
    </span>
  </el-dialog>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import el_week_picker from '../el-week-picker.vue';

export default {
  props: {
    visible: false,
    currentFilters: {
      type: Object,
      default: {
        functional_area_id: null,
        date_from: null,
        date_to: null,
      }
    },
    shiftsOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    rotation: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },
  data() {
    return {
      copyAndRotateFormVisible: false,
      copyAndRotateForm: {
        rotation: [],
        functional_area_id: null,
        original: {
          date_from: null,
          date_to: null,
        },
        copy: {
          date_from: null,
          date_to: null,
        }
      },
    }
  },
  watch: {
    rotation: {
      handler(value, o) {
        this.copyAndRotateForm.rotation = value;
      },
      deep: true,
    }
  },
  components: {
    'el-week-picker': el_week_picker,
  },
  methods: {
    copyAndRotateWeekPickerChange(value) {
      this.copyAndRotateForm.original.date_from = value[0];
      this.copyAndRotateForm.original.date_to = value[1];
    },
    checkOriginalDate(rule, value, callback) {
      console.log('checkOriginalDate');
      console.log(rule);
      console.log(value);
      if (this.copyAndRotateForm.original.date_from != null && this.copyAndRotateForm.original.date_to != null) {
        callback();
      }
      callback(new Error('Debe seleccionar una semana a copiar'));
    },
    handleCopyAndRotate() {
      this.$refs['copyAndRotateForm'].validate((valid) => {
        console.log(valid);
        if (valid) {
          axios.post('/api/employees/shiftsrotate', this.copyAndRotateForm).then((response) => {
            // console.log(response);
            // this.copyAndRotateFormVisible = false;
            // this.loadInfo(this.$route.query);
            this.$emit('submitted');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      // axios.post('/api/employees/shiftsrotate', this.copyAndRotateForm).then((response) => {
      //     // console.log(response);
      //     this.copyAndRotateFormVisible = false;
      //     this.loadInfo(this.$route.query);
      // });
    },
  },
}
</script>